import { AfterViewChecked, ContentChildren, Directive, ElementRef, HostListener, Input, QueryList, Renderer2 } from '@angular/core';

import { EqualizeParams } from '../equalize-params';
import { EqualizerService } from '../services/index';
import { EqualizerWatcherDirective } from './equalizer-watcher.directive';


@Directive({
    selector: '[equalizer]',
    exportAs: 'equalizer'
})
export class EqualizerDirective implements AfterViewChecked {
    @Input('equalizer')
    private _params: 'height' | 'width' | EqualizeParams = 'height';

    @Input('equalizerId')
    private _id: string | number;

    @ContentChildren(EqualizerWatcherDirective, {read: EqualizerWatcherDirective})
    private _watchers: QueryList<EqualizerWatcherDirective> = new QueryList<EqualizerWatcherDirective>();

    get params() {
        return this._params;
    }

    set params(value) {
        this._params = value;

        this.equalize();
    }

    get elementRef(): ElementRef {
        return this._elementRef;
    }

    get id(): string | number {
        return this._id;
    }

    set id(value: string | number) {
        this._id = value;
    }

    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer2,
        private _equalizerService: EqualizerService
    ) {
    }

    public ngAfterViewChecked(): void {
        this.equalize();
    }

    @HostListener('window:resize')
    private _onResize(): void {
        this.equalize();
    }

    public equalize() {
        if (!this._params) {
            this._params = 'height';
        }

        const params: EqualizeParams = Object.assign({property: 'height', reset: true}, typeof this._params === 'string' ? {property: this._params} : this._params);
        const watchers: ElementRef[] = this._watchers.filter((watcher) => {
            console.log('ID matching', watcher.id, this.id);
            if (watcher.id || this.id) {
                return watcher.id === this.id;
            }

            return watcher.elementRef.nativeElement !== this._elementRef.nativeElement;
        }).map((watcher) => watcher.elementRef);

        this._equalizerService.equalize(
            this._renderer,
            watchers,
            params
        );
    }
}
